import { always, compose, cond, T, not } from 'ramda';

import { REGISTER_PATH, UNAVAILABLE_PATH } from 'app/router/constants/paths';
import { isUserAuthenticated } from 'app/features/user/selectors';
import { isCouponValid } from 'app/features/couponCampaign/selectors';
import { freeTrialUrl } from 'app/features/checkout/selectors';

const ctaLink = cond([
  [compose(not, isUserAuthenticated), always(REGISTER_PATH)],
  [isCouponValid, freeTrialUrl],
  [T, always(`${UNAVAILABLE_PATH}?nextlevel=invalidcoupon`)],
]);

export { ctaLink };
